import { experienceBuilderApi } from 'api'

export const fetchPractitioners = (data: any) =>
  experienceBuilderApi.get<{
    data: any[]
    meta: { total: number; page: number; pageSize: number; totalPages: number }
    exploreMorePractitioners: any[]
  }>('/marketing-capabilities/practitioners', {
    params: {
      ...data,
    },
  })
